import React, {useState,useEffect} from 'react'
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faSearch, faAngleRight, faAngleDown, faTimes, faKey, faCheck} from "@fortawesome/free-solid-svg-icons"
import demoproduct from "../img/table-product.png"
import demopublihser from "../img/publisher-icon.png"
import { useDispatch, useSelector } from 'react-redux';
import { deletePublisher, getPublishers, mailtoPublisher } from '../util/api';
import ReactPaginate from "react-paginate"
import BeatLoader from 'react-spinners/BeatLoader';
import { updateNotificationSuccess } from '../redux/notificationRedux';
import { userRequest } from '../util/requestMethod';


export default function PublisherList() {
    
  const [searchedQuery, setsearchedQuery] = useState("")
  const dispatch = useDispatch();
  const [loader, setLoader] = useState(false);
  const [pageNumber, setPageNumber] = useState(0);
  const [publisherPerPage, setpublisherPerPage] = useState(10);
  const pageVisited = pageNumber * publisherPerPage;
  const [isModalOpen, setisModalOpen] = useState(false);
  const [isSetOnce, setisSetOnce] = useState(true);
  const [accesInfo, setaccesInfo] = useState({})
  const [password, setPassword] = useState("")

  const publishers = useSelector((state) => state.publisher.publishers);
  const books = useSelector((state) => state.book.books);
  const [isBookFound, setIsBookFound] = useState(null);
  const [deleteItem, setdeleteItem] = useState(null);
  const [allPublishers, setallPublishers] = useState(publishers);
  const [langType, setlangType] = useState("")
  let notification = useSelector((state)=> state.notification.notification)


  const lngtype = (value) => {
    var text = value.replace(/\s/g)
    //Dictionary for Unicode range of the languages
    var langdic = {
      "arabic" : /[\u0600-\u06FF]/,
      "persian" : /[\u0750-\u077F]/,
      "Hebrew" : /[\u0590-\u05FF]/,
      "Syriac" : /[\u0700-\u074F]/,
      "Bengali" : /[\u0980-\u09FF]/,
      "Ethiopic" : /[\u1200-\u137F]/,
      "Greek and Coptic" : /[\u0370-\u03FF]/,
      "Georgian" : /[\u10A0-\u10FF]/,
      "Thai" : /[\u0E00-\u0E7F]/,
      "english" : /^[a-zA-Z]+$/
        //add other languages her
    }  
    //const keys = Object.keys(langdic); //read  keys
    //const keys = Object.values(langdic); //read  values
    const keys = Object.entries(langdic); // read  keys and values from the dictionary
    Object.entries(langdic).forEach(([key, value]) => {  // loop to read all the dictionary items if not true
      if (value.test(text) === true){   //Check Unicode to see which one is true
        return setlangType(key); //print language name if unicode true   
      }
    });
  }

  useEffect(() => {
    setLoader(true);
    setTimeout(() => {
      dispatch(updateNotificationSuccess({sms:"",status:null}))
      setLoader(false);
    }, 2000);
    getPublishers(dispatch)
  }, [dispatch]);


  const handleSearch = (e) =>{
    setsearchedQuery(e.target.value)
    lngtype(e.target.value)
  }

  const handleSorting = (e) =>{
    let filterStatus = e.target.value;
    let copyData = [...publishers]
    if (filterStatus == 0) {
        let data = copyData.filter(publisher=>{
            if (publisher.status === 0) {
                return publisher
            }
        })
        setallPublishers(data)
    }else if (filterStatus == 1) {
        let data = copyData.filter(publisher=>{
            if (publisher.status === 1) {
                return publisher
            }
        })
        setallPublishers(data)
    }else if (filterStatus === "") {
        setallPublishers(publishers)
    }
  }

  const removeItem = (id, slug) => {
        books.filter((book) => {
        if (book.publisherSlug === slug) {
            return setIsBookFound(true)
        } else {
            return setIsBookFound(false), setdeleteItem(id);
        }
        });
    };

    const removeItemConfirm = () => {
        deletePublisher(deleteItem, dispatch).then((res) => {
            if (res === undefined) {
                dispatch(updateNotificationSuccess({sms:"Publisher Delete Failed",status:false}))
                setTimeout(() => {
                    dispatch(updateNotificationSuccess({sms:"",status:null}))
                }, 2000);
            } else {
                dispatch(updateNotificationSuccess({sms:"Publisher Delete Success",status:true}))
                setTimeout(() => {
                    dispatch(updateNotificationSuccess({sms:"",status:null}))
                }, 2000);
                getPublishers(dispatch)
            }
        });
        setIsBookFound(null)
    };

    const removeItemDenied = () =>{
        setIsBookFound(null)
    }

    const handleAccess = (id, name, phone, email) =>{
        setisModalOpen(true);
        generatePassword(); 
        setaccesInfo(
            {
                id:id,
                bn_publication: name,
                tnt: phone,
                email: email,
                isAdmin: true
            }
        )
    }

    const generatePassword = () =>{
        const randomPassword =
        Math.random().toString(26).slice(-6) + Math.random().toString(26).slice(-6);
  
        setPassword(randomPassword);
        return randomPassword;
    }

    const closeModal = () =>{
        setisModalOpen(false) 
        setPassword(null)
        setaccesInfo({});
    }

    const sendingAccessKey =()=>{
        let accessinfo = {...accesInfo, password: password};
        let {id, ...others} = accessinfo;
        mailtoPublisher(accessinfo.id, others)
        setisModalOpen(false)
    }


  const displayPublishers = publishers.filter(publisher=> {
    if (searchedQuery === "") {
      return publisher
    }
    else if (langType === 'Bengali'? publisher.bn_publication?.toLowerCase().includes(searchedQuery.toLowerCase()) : publisher.en_publication?.toLowerCase().includes(searchedQuery.toLowerCase())) {
      return publisher
    }
  }).slice(pageVisited, pageVisited + publisherPerPage)
    .map((publisher) => {
      return (
        <div className="table-row">
            <li>
                <img src={publisher.photo? `${process.env.REACT_APP_BASE_URL}/api/alluploads/publishersphoto/${publisher.photo}`:  `${process.env.REACT_APP_BASE_URL}/api/alluploads/default-publisher.jpg`} alt=""/>
                <a href={`${process.env.REACT_APP_BASE_URL}/publisher/${publisher.publisherSlug}`} target="_blank">{publisher.bn_publication}</a>
            </li>
            <li>{publisher.tnt}</li>
            <li>
            {publisher.email}
            </li>
            <li>{publisher.owner? publisher.owner : ""}</li>
            <li></li>
            <li>
                <p className={publisher.status === 0? "status success" : "status pending"}>{publisher.status === 0? "Published" : "Unpublished"}</p>
            </li>
            <li>
                <div className="actions">
                    <Link to={`/edit-publisher/${publisher._id}`} className="edit">
                        <svg width="22" height="24" viewBox="0 0 22 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0 0.155029V22.2202H7.9615C8.12981 22.222 8.28714 22.1358 8.37312 21.9921C8.45727 21.8485 8.45727 21.6725 8.37312 21.5288C8.28714 21.3852 8.12981 21.299 7.9615 21.3008H0.936647V1.07441H9.36648V7.51007H15.923V12.5667C15.9212 12.7319 16.009 12.8863 16.1553 12.9707C16.3017 13.0533 16.481 13.0533 16.6273 12.9707C16.7737 12.8863 16.8615 12.7319 16.8597 12.5667V6.86363L16.7279 6.71998L10.1714 0.284317L10.0251 0.155029H0ZM10.3031 1.73521L15.2498 6.59069H10.3031V1.73521ZM19.6257 11.6042C19.1336 11.6042 18.6397 11.782 18.2646 12.1501L17.9427 12.4805L17.9573 12.4948L10.7275 19.5913C10.6672 19.6452 10.6214 19.7152 10.5958 19.7924L9.80553 22.5506C9.75796 22.7104 9.80004 22.8828 9.91895 23.0031C10.0379 23.1216 10.2117 23.1683 10.3763 23.1252L13.1862 22.3925C13.2649 22.3674 13.3363 22.3225 13.3911 22.2633L20.7965 15.0519C20.855 15.0016 20.9008 14.9369 20.9282 14.8651L20.9868 14.822C21.7368 14.0858 21.7368 12.8863 20.9868 12.1501C20.6117 11.782 20.1178 11.6042 19.6257 11.6042ZM18.6159 13.1413L20.0208 14.5203L12.835 21.5306L11.4593 20.2234L11.4739 20.1659L18.6159 13.1413Z" fill="#0D99FF"/>
                        </svg>
                    </Link>
                    <a onClick={() => removeItem(publisher._id, publisher.publisherSlug)} className="delete">
                        <svg width="21" height="26" viewBox="0 0 21 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8.71057 0C7.792 0 7.03584 0.740313 7.03584 1.63962V2.7327H2.66366C2.60337 2.72295 2.54186 2.72295 2.48157 2.7327H1.4534C1.37943 2.73168 1.30598 2.74506 1.23734 2.77206C1.16869 2.79907 1.10621 2.83916 1.05353 2.89002C1.00085 2.94087 0.959017 3.00147 0.930464 3.06828C0.901911 3.1351 0.887207 3.20681 0.887207 3.27924C0.887207 3.35167 0.901911 3.42338 0.930464 3.4902C0.959017 3.55702 1.00085 3.61761 1.05353 3.66846C1.10621 3.71932 1.16869 3.75941 1.23734 3.78642C1.30598 3.81343 1.37943 3.8268 1.4534 3.82578H2.01165V23.5012C2.01165 24.4005 2.76781 25.1408 3.68638 25.1408H18.2007C19.1193 25.1408 19.8754 24.4005 19.8754 23.5012V3.82578H20.4337C20.5077 3.8268 20.5811 3.81343 20.6498 3.78642C20.7184 3.75941 20.7809 3.71932 20.8336 3.66846C20.8862 3.61761 20.9281 3.55702 20.9566 3.4902C20.9852 3.42338 20.9999 3.35167 20.9999 3.27924C20.9999 3.20681 20.9852 3.1351 20.9566 3.06828C20.9281 3.00147 20.8862 2.94087 20.8336 2.89002C20.7809 2.83916 20.7184 2.79907 20.6498 2.77206C20.5811 2.74506 20.5077 2.73168 20.4337 2.7327H19.411C19.3507 2.72295 19.2892 2.72295 19.2289 2.7327H14.8512V1.63962C14.8512 0.740313 14.0951 0 13.1765 0H8.71057ZM8.71057 1.09308H13.1765C13.4861 1.09308 13.7348 1.33654 13.7348 1.63962V2.7327H8.15233V1.63962C8.15233 1.33654 8.401 1.09308 8.71057 1.09308ZM3.12813 3.82578H7.50031C7.5606 3.83554 7.62211 3.83554 7.6824 3.82578H14.1992C14.2595 3.83554 14.321 3.83554 14.3813 3.82578H18.759V23.5012C18.759 23.8043 18.5103 24.0478 18.2007 24.0478H3.68638C3.37681 24.0478 3.12813 23.8043 3.12813 23.5012V3.82578ZM14.8458 9.83025C14.6986 9.83366 14.5586 9.8939 14.4566 9.99784L10.9435 13.4372L7.43053 9.99784C7.37851 9.94549 7.3163 9.90387 7.24757 9.87545C7.17884 9.84703 7.10499 9.83239 7.03039 9.83238C6.91933 9.83241 6.81081 9.86487 6.7187 9.92559C6.62658 9.98632 6.55506 10.0726 6.51327 10.1733C6.47148 10.274 6.46133 10.3847 6.4841 10.4911C6.50688 10.5975 6.56156 10.6949 6.64114 10.7707L10.1542 14.21L6.64114 17.6494C6.58757 17.6998 6.54479 17.7601 6.51532 17.8268C6.48586 17.8936 6.47029 17.9654 6.46953 18.0381C6.46878 18.1108 6.48285 18.183 6.51092 18.2503C6.539 18.3176 6.58051 18.3788 6.63303 18.4302C6.68554 18.4816 6.74802 18.5222 6.81678 18.5497C6.88554 18.5772 6.95922 18.591 7.03348 18.5903C7.10775 18.5895 7.18113 18.5743 7.2493 18.5454C7.31748 18.5166 7.37909 18.4747 7.43053 18.4222L10.9435 14.9829L14.4566 18.4222C14.508 18.4747 14.5696 18.5166 14.6378 18.5454C14.706 18.5743 14.7793 18.5895 14.8536 18.5903C14.9279 18.591 15.0015 18.5772 15.0703 18.5497C15.1391 18.5222 15.2015 18.4816 15.2541 18.4302C15.3066 18.3788 15.3481 18.3176 15.3762 18.2503C15.4042 18.183 15.4183 18.1108 15.4176 18.0381C15.4168 17.9654 15.4012 17.8936 15.3718 17.8268C15.3423 17.7601 15.2995 17.6998 15.2459 17.6494L11.7329 14.21L15.2459 10.7707C15.327 10.6944 15.3827 10.5958 15.4056 10.488C15.4285 10.3802 15.4176 10.2682 15.3743 10.1665C15.3311 10.0649 15.2575 9.97836 15.1632 9.91836C15.0689 9.85836 14.9582 9.82765 14.8458 9.83025Z" fill="#EE3E33"/>
                        </svg>
                    </a>
                    <a className="access" onClick={()=>handleAccess(publisher._id,publisher.bn_publication, publisher.tnt, publisher.email)}>
                        <FontAwesomeIcon icon={faKey} />
                    </a>
                </div>
            </li>
        </div>
      );
    });

    const pageCount = Math.ceil(publishers.length / publisherPerPage);
    const changePage = ({ selected }) => {
      setPageNumber(selected);
    };

    const [publisherFile, setpublisherFile] = useState(null);
    const [publisherFileStatus, setpublisherFileStatus] = useState(null);
    const handleUploadPublishers = async (e) =>{
        const data = new FormData();
        data.append('file',publisherFile)
        const res = await userRequest.post(`${process.env.REACT_APP_BASE_URL}/api/publisher/addFromCSV`, data)
        .then((data)=>{
            console.log(data);
        })
    }


  return (
    <>
    {/* {isSetOnce === true? (
        <div className="accessModal">
            <div className="accessModalInner">
                <FontAwesomeIcon icon={faTimes} onClick={()=>closeModal()}/>
                <div className="accessInfo" style={{display:"flex",flexDirection:"column",justifyContent:"center",padding:"0",height:"100%"}}>
                    <h1>Bulk Input</h1>
                    <form>
                        <input type='file' onChange={(e)=>setpublisherFile(e.target.files[0])} className="form-control mb-3" />
                        <button type="button" className="btn theme-btn" onClick={handleUploadPublishers}>Upload</button>
                    </form>
                </div>
            </div>
        </div>
    ) : (
        ""
    )
    } */}
    {isModalOpen === true? (
        <div className="accessModal">
            <div className="accessModalInner">
                <FontAwesomeIcon icon={faTimes} onClick={()=>closeModal()}/>
                <div className="accessInfo">
                    <h1>{accesInfo.bn_publication}</h1>
                    <form>
                        <div className="form-group">
                            <input type="text" value={accesInfo.tnt} className="form-control" />
                        </div>
                        <div className="form-group">
                            <input type="email" value={accesInfo.email} className="form-control" />
                        </div>
                        <div className="form-group">
                            <input type="text" value={password}  className="form-control" placeholder="Password" />
                            <button type="button" onClick={generatePassword}>Generate Password</button>
                        </div>
                        <button type="button" className="btn theme-btn" onClick={sendingAccessKey}>Send Confirmation</button>
                    </form>
                </div>
            </div>
        </div>
    ) : (
        ""
    )
    }
    {isBookFound === true ? (
          <div className="dialougeBox">
            <div className="dialougeBoxInner">
              <p>This Publisher is assigned in a book.You can't delete it</p>
              <button className="btn theme-btn" onClick={removeItemDenied}>Ok</button>
            </div>
          </div>
      ) : isBookFound === false ? (
        <div className="dialougeBox">
          <div className="dialougeBoxInner">
            <p>Are you sure? You want to delete it?</p>
            <button className="btn theme-btn" onClick={removeItemConfirm}>Yes</button>
            <button className="btn theme-btn" onClick={removeItemDenied}>No</button>
          </div>
        </div>
      ) : (
        ""
    )}
    {notification.status === true?
        <div className='notification-bar success'>
          <FontAwesomeIcon icon={faCheck} />
          <p>{notification.sms}</p>
        </div>
        : notification.status === false?
        <div className='notification-bar failed'>
          <FontAwesomeIcon icon={faTimes} />
          <p>{notification.sms}</p>
        </div>
        :
        ""
      }
    <div className="content-area-inner list-page">
      <div className="container-fluid">
        <div className="breadcumb">
          <Link to="/">Dashboard</Link>
          <FontAwesomeIcon icon={faAngleRight} />
          <Link to="/">Publisherlist</Link>
        </div>
        <div className="heading">
          <h1>Publisher List</h1>
        </div>
        <div className="col-lg-12">
            <div className="row">
                <div className="col-lg-8">
                    <div className="tab-btns">
                        <div className="tab-btn active">All Items ({publishers.length})</div>
                        <div className="tab-btn">Drafts (20)</div>
                    </div>
                </div>
                <div className="col-lg-4">
                    <div className="group-btn">
                        <Link to="/" className="btn theme-btn-alt">Bulk uploader</Link>
                        <Link to="/addpublisher" className="btn theme-btn">
                            Add Publisher 
                            <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 5.5H7V0.5H5V5.5H0V7.5H5V12.5H7V7.5H12V5.5Z" fill="white"/>
                            </svg>
                        </Link>
                    </div>
                </div>
            </div>
            <div className="tab-content">
                <div className="tab-wrap">
                    <div className="theme-card">
                        <div className="theme-card-header">
                            <div className="row">
                                <div className="col-lg-8">
                                    <div className="searchbar">
                                        <div className="form-group">
                                            <input type="text" placeholder="Search" onChange={(e)=>handleSearch(e)}/>
                                            <button type="submit" className="btn">
                                                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M13.4523 11.4716H12.6623L12.3823 11.2016C13.5823 9.80157 14.2023 7.89157 13.8623 5.86157C13.3923 3.08157 11.0723 0.861573 8.27229 0.521573C4.04229 0.00157288 0.482286 3.56157 1.00229 7.79157C1.34229 10.5916 3.56229 12.9116 6.34229 13.3816C8.37229 13.7216 10.2823 13.1016 11.6823 11.9016L11.9523 12.1816V12.9716L16.2023 17.2216C16.6123 17.6316 17.2823 17.6316 17.6923 17.2216C18.1023 16.8116 18.1023 16.1416 17.6923 15.7316L13.4523 11.4716ZM7.45229 11.4716C4.96229 11.4716 2.95229 9.46157 2.95229 6.97157C2.95229 4.48157 4.96229 2.47157 7.45229 2.47157C9.94229 2.47157 11.9523 4.48157 11.9523 6.97157C11.9523 9.46157 9.94229 11.4716 7.45229 11.4716Z" fill="#1D1D1D"/>
                                                </svg>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4">
                                    <div className="list-filter d-flex justify-content-end">
                                        <div className="form-group">
                                            <select className="form-control" onChange={handleSorting}>
                                                <option value="">Filter</option>
                                                <option value="0">Published</option>
                                                <option value="1">Unpublished</option>
                                            </select>
                                        </div>
                                        <div className="form-group">
                                            <select className="form-control" onChange={(e)=>{setpublisherPerPage(e.target.value)}}>
                                                <option value="10">Publisher per page</option>
                                                <option value="20">20 per page</option>
                                                <option value="30">30 per page</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {loader?
                            <BeatLoader color={"#0D99FF"} loading={loader} size={15}/>
                            :
                            <div className="theme-card-body">
                                <div className="table book-table">
                                    <ul className="custom-table-header">
                                        <li>Publisher</li>
                                        <li>Tnt</li>
                                        <li>Email</li>
                                        <li>Owner</li>
                                        <li>Sold</li>
                                        <li>Status</li>
                                        <li>Actions</li>
                                    </ul>
                                    <ul className="custom-table-body">
                                        {displayPublishers}
                                    </ul>
                                    <ReactPaginate
                                        previousLabel={"Prev"}
                                        nextLabel={"Next"}
                                        pageCount={pageCount}
                                        onPageChange={changePage}
                                        containerClassName={"pagination"}
                                        activeClassName={"actvie-page"}
                                    />
                                </div>
                            </div>
                        }
                    </div>
                </div>
                <div className="tab-wrap">
                    {/* <div className="theme-card">
                        Draft
                    </div> */}
                </div>
            </div>
        </div>
      </div>
    </div>
    </>
  )
}
